module.exports = __webpack_public_path__ + "static/img/hk_ci.479a4cdc.jpg";